import type { Settings as LayoutSettings } from "@ant-design/pro-components";

const defaultSettings: LayoutSettings = {
  title: "AI Exam",
  navTheme: "light",
  layout: "mix",
  contentWidth: "Fluid",
  fixedHeader: true,
  fixSiderbar: true,
  splitMenus: false,
  colorPrimary: "#1677ff",
};

export default defaultSettings;
